import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import {
  addDaysToDateHelper,
  formatDateHelper,
  subtractDaysFromDateHelper,
} from '@/utils/dateUtils';

const DEFAULT_PAST_DAYS = Number(import.meta.env.VITE_DEFAULT_PAST_DAYS) || 90;
const DEFAULT_FUTURE_DAYS =
  Number(import.meta.env.VITE_DEFAULT_FUTURE_DAYS) || 90;

const initialState = {
  startDate: formatDateHelper({
    date: subtractDaysFromDateHelper(moment(), DEFAULT_PAST_DAYS).toDate(),
  }),
  endDate: formatDateHelper({
    date: addDaysToDateHelper(moment(), DEFAULT_FUTURE_DAYS).toDate(),
  }),
  includeRecordsWithNullReleaseDate: true,
};

const releaseDashboardSlice = createSlice({
  name: 'releaseDashboard',
  initialState,
  reducers: {
    setDatesSliceAction: (state, action) => {
      const { startDate, endDate } = action.payload;

      state.startDate = startDate
        ? formatDateHelper({ date: moment(startDate).toDate() })
        : null;
      state.endDate = endDate
        ? formatDateHelper({ date: moment(endDate).toDate() })
        : null;
    },

    setIncludeNullRecordsSliceAction: (state, action) => {
      state.includeRecordsWithNullReleaseDate = action.payload;
    },

    setAllDatesSliceAction: (state, action) => {
      const { startDate, endDate, includeRecordsWithNullReleaseDate } =
        action.payload;

      state.startDate = startDate
        ? formatDateHelper({ date: moment(startDate).toDate() })
        : null;
      state.endDate = endDate
        ? formatDateHelper({ date: moment(endDate).toDate() })
        : null;
      state.includeRecordsWithNullReleaseDate =
        includeRecordsWithNullReleaseDate ?? true;
    },

    resetDatesSliceAction: () => ({
      ...initialState,
    }),
  },
});

export const {
  setDatesSliceAction,
  setIncludeNullRecordsSliceAction,
  setAllDatesSliceAction,
  resetDatesSliceAction,
} = releaseDashboardSlice.actions;

export default releaseDashboardSlice.reducer;
